import React from 'react';
import Blog from '../../components/templates/Blog';
import BlogList from '../../components/templates/BlogList/BlogList';
import Categories from '../../data/blog/categories';
import BlogPosts from '../../data/blog/posts';

function BlogDetailPage({ posts, categories }) {
  return <BlogList posts={posts} categories={categories} />;
}

export const config = {
  amp: false,
};

export async function getStaticProps() {
  const posts = BlogPosts.sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));

  return {
    props: { posts, categories: Categories },
  };
}

export default BlogDetailPage;
